/**
 * Preact mounting helper for voice-mode UI islands.
 *
 * The widget's existing chrome is imperative DOM; the new voice
 * surface uses Preact + signals. We bridge by mounting Preact apps
 * inside specific anchor elements the imperative code creates. The
 * imperative tree owns layout + lifecycle of the anchor; Preact owns
 * what's *inside* it.
 *
 * Each mount call returns a teardown function for clean unmount —
 * critical on cross-page widget remounts so we don't leak signals
 * subscriptions.
 */

import { render, type ComponentChild } from 'preact';

export function mountPreactIsland(
  anchor: HTMLElement,
  node: ComponentChild,
): () => void {
  render(node, anchor);
  return () => {
    render(null, anchor);
  };
}
